import React,{ useState, useContext } from "react";  
import Global from '../../APIConfig';
import { useNavigate,Link } from "react-router-dom";
import AuthUser from "../../AuthUser";
import { AppContext } from '../../context/AppContext';

function FinanceLeftPanel()
{
    let navigate = useNavigate();
    const{headers1,headers2,logout}=AuthUser();
    const[show,SetShow]=useState('close');
    const items = JSON.parse(localStorage.getItem('user'));
    const user_privilage_string = items.user_privilage_array;
    const user_privilage_array = user_privilage_string.split(',').map(Number);
    const userlogout=()=>{
        logout();
        navigate('/');
    }
    const [DropdownType, setDropdownType] = useState('');
    const { companyname } = useContext(AppContext);
    return (
        <div className={`sidebar ${show}`}>
            <div className="logo-details">
                <div className="head_icon" onClick={()=>{SetShow(show=='close'?'show':'close')}}>
                    <i className="bx bx-menu"></i>
                </div>
                <span className="logo_name">{companyname}</span>
            </div>
            <ul className="nav-links">
                <li className={DropdownType=='dashboard'?`showMenu`:''}>
                    <div className="iocn-link">
                        <a href="#" onClick={()=>{DropdownType!='dashboard'?setDropdownType('dashboard'):setDropdownType('')}}>
                            <i className="bx bx-grid-alt"></i>
                            <span className="link_name">Dashboard</span>
                        </a>
                        <i className="bx bxs-chevron-down arrow"></i>
                    </div>
                    <ul className="sub-menu">
                        <li><a className="link_name" href="Admin-Dash">Dashboard</a></li>
                        <li><a href="/Admin-Dash">Master Dashboard</a></li>
                    </ul>
                </li>
                {items.usertype =='AD' || user_privilage_array.includes(20) ?
                <li className={DropdownType=='reports'?`showMenu`:''}>
                    <div className="iocn-link" bis_skin_checked="1">
                        <a href="#" onClick={()=>{DropdownType!='reports'?setDropdownType('reports'):setDropdownType('')}}>
                        <i className="bx bx-receipt"></i>
                        <span className="link_name">Reports</span>
                        </a>
                        <i className="bx bxs-chevron-down arrow"></i>
                    </div>
                    <ul className="sub-menu">
                        <li><a className="link_name" href="#">Customer Payment Reports</a></li>
                        <li><a href="/CustomerCreditOverview">Customer Credit Reports</a></li>
                        <li><a href="/CustomerContractOverview">Customer Cantrect Report</a></li>
                        <li><a href="/CustomerWalletOverview">Customer Wallet Report</a></li>
                    </ul>
                </li>
                :
                ""
                }
                {items.usertype =='AD' || user_privilage_array.includes(20) ?
                <li className={DropdownType=='report_two'?`showMenu`:''}>
                    <div className="iocn-link" bis_skin_checked="1">
                        <a href="#" onClick={()=>{DropdownType!='report_two'?setDropdownType('report_two'):setDropdownType('')}}>
                        <i className="bx bx-receipt"></i>
                        <span className="link_name">Reports</span>
                        </a>
                        <i className="bx bxs-chevron-down arrow"></i>
                    </div>
                    <ul className="sub-menu">
                        <li><a className="link_name" href="#">Reports</a></li>
                        <li><a href="/ShipmentReport">Shipment Reports</a></li>
                        <li><a href="/PaymentReport">Payment Report</a></li>
                        {/* <li><a href="ClientSalesReport">Sales By Client Report</a></li> */}
                        <li><a href="/HubReport">Hub Report</a></li>
                        <li><a href="/AgentReport">Agent Report</a></li>
                        <li><a href="/DriverReport">Driver Report</a></li>
                        <li><a href="/CODReport">COD Report</a></li>
                    </ul>
                </li>
                :
                ""
                }
                
                {items.usertype =='AD' || user_privilage_array.includes(20) ?
                <li className={DropdownType=='commission'?`showMenu`:''}>
                    <div className="iocn-link" bis_skin_checked="1">
                        <a href="#" onClick={()=>{DropdownType!='commission'?setDropdownType('commission'):setDropdownType('')}}>
                        <i className="bx bx-file"></i>
                        <span className="link_name">Commission Management </span>
                        </a>
                        <i className="bx bxs-chevron-down arrow"></i>
                    </div>
                    <ul className="sub-menu">
                        <li><a className="link_name" href="#">Commission Management </a></li>
                        {/* <li><a href="/ShipmentReport">Customer Service Charged</a></li>
                        <li><a href="customer_invoice.php">Customer Cod</a></li> */}
                        <li><a href="/HubCommissionReport">Hub Commission</a></li>
                        <li><a href="/DriverCommissionReport">Driver Commission</a></li>
                    </ul>
                </li>
                :
                ""
                }
                {/* {items.usertype =='AD' || user_privilage_array.includes(20) ?
                <li className={DropdownType=='payment'?`showMenu`:''}>
                    <div className="iocn-link" bis_skin_checked="1">
                        <a href="#" onClick={()=>{DropdownType!='payment'?setDropdownType('payment'):setDropdownType('')}}>
                        <i className="bx bx-credit-card"></i>
                        <span className="link_name">Payment Detail </span>
                        </a>
                        <i className="bx bxs-chevron-down arrow"></i>
                    </div>
                    <ul className="sub-menu">
                        <li><a className="link_name" href="#">Payment Detail </a></li>
                        <li><a href="customer_invoice.php">Payment Detail</a></li>
                    </ul>
                </li>
                :
                ""
                }
                {items.usertype =='AD' || user_privilage_array.includes(20) ?
                <li className={DropdownType=='invoice'?`showMenu`:''}>
                    <div className="iocn-link" bis_skin_checked="1">
                        <a href="#" onClick={()=>{DropdownType!='invoice'?setDropdownType('invoice'):setDropdownType('')}}>
                        <i className="bx bx-id-card"></i>
                        <span className="link_name">Invoice Detail </span>
                        </a>
                        <i className="bx bxs-chevron-down arrow"></i>
                    </div>
                    <ul className="sub-menu">
                        <li><a className="link_name" href="#">Invoice Detail </a></li>
                        <li><a href="customer_invoice.php">Quick Invoice</a></li>
                        <li><a href="customer_invoice.php">Customer Invoice</a></li>
                        <li><a href="customer_invoice.php">Agent Invoice</a></li>
                    </ul>
                </li>
                :
                ""
                } */}
                {items.usertype =='AD' || user_privilage_array.includes(20) ?
                <li className={DropdownType=='stock'?`showMenu`:''}>
                    <div className="iocn-link" bis_skin_checked="1">
                        <a href="#" onClick={()=>{DropdownType!='stock'?setDropdownType('stock'):setDropdownType('')}}>
                        <i className="fa fa-cubes" aria-hidden="true"></i>
                        <span className="link_name">Stock Management </span>
                        </a>
                        <i className="bx bxs-chevron-down arrow"></i>
                    </div>
                    <ul className="sub-menu">
                        <li><a className="link_name" href="#">Stock Management </a></li>
                        <li><a href="/Stocklist">Stock Management</a></li>
                    </ul>
                </li>
                :
                ""
                }
                <li>
                <div className="profile-details">
                    <div className="profile-content">
                    <img src={`${Global.logoUrl}${items.profile_image}`} alt="profileImg" />
                    </div>
                    <div className="name-job">
                    <div className="profile_name">{items.name}</div>
                    <div className="job">{items.company}</div>
                    </div>
                    <i className="bx bx-log-out" onClick={()=>userlogout()}></i>
                </div>
                </li>
            </ul>
        </div>
    );

}
export default FinanceLeftPanel;